<template>
  <AppWithLoading v-slot:default="{ localLoading, loader }">
    <div class="agree-block">
      <VCheckbox
        v-model="agreePublic"
        :label="$t('agreePublic')"
        class="agree-block__item"
      >
        <template #label>
          <span class="mr-1">
            {{ $t('agreePublic') }}
            <a
              target="_blank"
              :href="offerLink"
              @click="handleLinkClick"
            >
              {{ $t('offer') }}
            </a>
          </span>
        </template>
      </VCheckbox>
    </div>
    <VBtn class="mt-6" :disabled="!canProceed" @click="loader(() => pay())">
      Оплатить
    </VBtn>
    <div class="mt-10 mb-4">
      <img style="width: 300px;" :src="require('@/assets/img/payments/all.svg')" />
    </div>
    <VDialog
      persistent
      max-width="882"
      content-class="dialog"
      v-model="dialog"
    >
      <VCard>
        <VCardTitle>
          Перенаправление
        </VCardTitle>
        <VCardText>
          Вы будете перенаправлены на страницу с оплатой...
          <Preloader />
        </VCardText>
      </VCard>
    </VDialog>
  </AppWithLoading>
</template>

<script>
import useAlfabank from '@/compositions/accounting/useAlfabank';
import {
  computed, ref, toRefs, watch,
} from '@vue/composition-api';
import AppWithLoading from '@/components/AppWithLoading';
import Preloader from '@/components/Preloader.vue';
import { useI18n } from 'vue-i18n-composable';
import usePayment from '@/compositions/accounting/usePayment';
import { paymentDrivers } from '@/enums';

export default {
  name: 'AlfaQuotaPayment',
  components: { AppWithLoading, Preloader },
  props: {
    newCard: {
      type: Boolean,
      default: false,
    },
    methodId: {
      type: Number,
      default: null,
    },
    quotaType: {
      type: String,
      required: true,
    },
    count: {
      type: Number,
      required: true,
    },
  },
  setup(props, { emit }) {
    const {
      count, methodId, newCard, quotaType,
    } = toRefs(props);
    const { driver } = usePayment();
    const { quotaPayment } = useAlfabank();
    const dialog = ref(false);

    const { locale } = useI18n();

    const offerLink = computed(() => (locale.value.toLowerCase() === 'ru'
      ? process.env.VUE_APP_RULES_URL
      : process.env.VUE_APP_CONFIDENTIAL_URL));

    async function pay() {
      const result = await quotaPayment({
        count: count.value,
        itemType: quotaType.value,
        paymentMethodId: methodId.value || null,
      });

      if (result && result.redirect) {
        dialog.value = true;
        document.location.href = result.redirect;
      } else {
        emit('success');
      }
    }

    const agreePublic = ref(true);
    const linkClicked = ref(false);

    const canProceed = computed(() => {
      return agreePublic.value && (newCard.value || methodId.value);
    });

    const previousAgreePublicValue = ref(agreePublic.value);

    watch(agreePublic, (newValue) => {
      if (linkClicked.value) {
        if (newValue !== previousAgreePublicValue.value) {
          agreePublic.value = previousAgreePublicValue.value;
        }
        linkClicked.value = false;
      } else {
        previousAgreePublicValue.value = newValue;
      }
    });

    function handleLinkClick(event) {
      previousAgreePublicValue.value = agreePublic.value;
      linkClicked.value = true;
      event.stopPropagation();
      event.preventDefault();
      window.open(offerLink.value, '_blank');
    }

    return {
      pay,
      dialog,
      offerLink,
      agreePublic,
      canProceed,
      driver,
      paymentDrivers,
      handleLinkClick,
    };
  },
};
</script>

<style scoped lang="scss">
.agree-block {
  &__item {
    width: fit-content;
  }
}
</style>

<i18n lang="yml" locale="ru">
agreePublic: 'Принимаю условия публичной '
offer: оферты
confirm: Подтвердить оплату
</i18n>
<i18n lang="yml" locale="en">
agreePublic: 'I accept the '
offer: terms and conditions
confirm: Confirm payment
</i18n>
